import { Component, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { LangService } from './shared/lang.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})

@Injectable()
export class AppComponent implements OnInit, AfterViewInit {
  isMultiColorActive = environment.isMultiColorActive;
  constructor(private langService: LangService, private renderer: Renderer2) {

  }

  ngOnInit(): void {
    this.langService.init();
  }

  ngAfterViewInit(): void {
    // Reveal once the webfonts are in, rather than on a fixed 1s timer, so text
    // is never painted in a fallback face and then reflowed when the real one
    // arrives. The race is a safety net: if fonts are slow, blocked or the API
    // is missing, the page still shows.
    const reveal = () => {
      this.renderer.addClass(document.body, 'show');
      setTimeout(() => {
        this.renderer.addClass(document.body, 'default-transition');
      }, 500);
    };

    const fonts = (document as any).fonts;
    if (fonts && fonts.ready) {
      Promise.race([
        fonts.ready,
        new Promise((resolve) => setTimeout(resolve, 1500)),
      ]).then(reveal);
    } else {
      setTimeout(reveal, 1000);
    }
  }
}
